import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametresInstance } from "../../Controls/Parameters";
import { ParametreDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { RubriqueDto } from "../../../dto/GenApi.iNotPaie.Dto/RubriqueDto";
import { ScenarioDto } from "../../../dto/GenApi.iNotPaie.Dto/ScenarioDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalAjoutUpdateScenario extends Vue {
	public isUpdate = false;
	public scenario: ScenarioDto = {
    	Parametre: { Id: 0, Modifiable: true, EstVisiblePst: false, EstVisibleEtudePst: false, EstArchive: false },
    	Rubriques: []
	};

	public rubriquesScenario: RubriqueDto[] = [];
	public rubriquesScenarioFiltred: RubriqueDto[] = [];

	public listeLibelles: ParametreDto[] = [];
	public listeRubriques: RubriqueDto[] = [];
	public listeRubriquesFiltred: RubriqueDto[] = [];
	public filterTypeRubrique = "A";
	public currentOrderColumn = "LibelleRubrique";
	public orderingDesc = true;
	public filterName = "";
    public arrondis: ParametreDto[] = ParametresInstance.listeArrondis;

    public Init(listeRubriques: any, filterTypeScenario?: string, id?: any): void {
        this.filterName = "";
        this.isUpdate = id != undefined;
        this.listeRubriques = listeRubriques;
    	this.filterTypeRubrique = "A";
    	if (this.isUpdate) {
    		ServicesFactoryInstance.ScenariosService.getScenario(id, (data) => {
    			this.scenario = data;
                this.rubriquesScenario = this.scenario.Rubriques;
    			this.doFilter();
    		});
    	} else if (!this.isUpdate) {
    		this.scenario = {
    			Parametre: {
    				Id: 0,
    				Modifiable: true,
    				EstVisiblePst: false,
    				EstVisibleEtudePst: false,
                    EstArchive: false,
                    CodeCategorie: filterTypeScenario
    			},
				Rubriques: []
    		};
    		this.rubriquesScenario = this.scenario.Rubriques;
    		this.doFilter();
    	}
    	this.$forceUpdate();
	}

	public annuler(): void {
    	$("#modalAjoutUpdateScenario").modal("hide");
	}

	public getLibelleRubrique(code: string): string {
    	if (code != undefined) {
    		if (this.listeRubriques.filter(r => r.CodeRubrique == code).length > 0) {
    			const rub = this.listeRubriques.filter(r => r.CodeRubrique == code)[0];

    			return rub.LibelleRubrique != undefined ? rub.LibelleRubrique : "";
    		}
    	}

    	return "";
	}

	public orderBy(columnName: string): void {
    	if (this.currentOrderColumn == columnName) {
    		this.orderingDesc = !this.orderingDesc;
    	} else {
    		this.orderingDesc = true;
    	}
    	this.currentOrderColumn = columnName;
    	this.doOrder();
	}

	public doOrder(): void {
    	const orderingDesc = this.orderingDesc;
    	const columnName = this.currentOrderColumn;
    	if (this.listeRubriquesFiltred != undefined) {
    		this.listeRubriquesFiltred = this.listeRubriquesFiltred.sort(function(a, b) {
    			if (a[columnName] < b[columnName]) {
					return (orderingDesc ? -1 : 1);
				}
    			if (a[columnName] > b[columnName]) {
					return (orderingDesc ? 1 : -1);
				}

    			return 0;
    		});
    	}
    }

	public doFilter(): void {
        // Filtrer rubriquesScenario selon filterTypeRubrique et filterName
    	this.rubriquesScenarioFiltred = this.rubriquesScenario.filter(rubrique => {
    		return rubrique.LibelleRubrique != undefined && rubrique.CodeNature?.toLowerCase() === this.filterTypeRubrique?.toLowerCase() &&
                (rubrique.LibelleRubrique?.toLowerCase().includes(this.filterName.toLowerCase()) ||
                rubrique.CodeRubrique?.toLowerCase().includes(this.filterName.toLowerCase()));
        });

        // Filtrer listeRubriques selon filterTypeRubrique et filterName
        // Et on s'assure qu'il n'y a pas de rubrique déjà présente dans rubriquesScenarioFiltred
    	this.listeRubriquesFiltred = this.listeRubriques.filter(rubrique => {
    		return rubrique.LibelleRubrique != undefined && rubrique.CodeNature?.toLowerCase() === this.filterTypeRubrique?.toLowerCase() &&
                !this.rubriquesScenarioFiltred.some(scenarioRubrique =>
                	scenarioRubrique.CodeRubrique?.toLowerCase() === rubrique.CodeRubrique?.toLowerCase() &&
                    scenarioRubrique.LibelleRubrique?.toLowerCase() === rubrique.LibelleRubrique?.toLowerCase()
                ) &&
                (rubrique.LibelleRubrique?.toLowerCase().includes(this.filterName.toLowerCase()) ||
                rubrique.CodeRubrique?.toLowerCase().includes(this.filterName.toLowerCase()));
        });

    	this.doOrder();
	}

	public checkCodeRubrique(code: any): boolean {
    	return (code == "" || code == undefined) || this.listeRubriques.filter(r => r.CodeRubrique == code).length != 0;
	}

	public filtreTableau(action: string, id: number): void {
    	if (action == "ajout") {
    		this.rubriquesScenario.push(this.listeRubriques.filter(r => r.Id == id)[0]);
    	} else {
    		this.rubriquesScenario = this.rubriquesScenario.filter(r => r.Id != id);
        }
        this.doFilter();
    	this.$forceUpdate();
	}

	public save(): boolean | void {
		// Validation
    	const errorMessage: string[] = [];
    	if (this.scenario.Parametre.Libelle == undefined) {
    		errorMessage.push("Le Libelle est obligatoire");
    	}
    	if (errorMessage.length > 0) {
    		for (let i = 0; i < errorMessage.length; i++) {
    			NotificationServiceInstance.SendFailed(errorMessage[i]);
    		}

    		return false;
    	}

    	if (!this.checkCodeRubrique(this.scenario.Parametre.CodeRubrique1) ||
            !this.checkCodeRubrique(this.scenario.Parametre.CodeRubrique2) ||
            !this.checkCodeRubrique(this.scenario.Parametre.CodeRubrique3)) {
    		NotificationServiceInstance.SendFailed("Un code rubrique n'est pas valide");

    		return false;
    	}

    	if (this.isUpdate) {
    		this.scenario.Rubriques = this.rubriquesScenario;
    		ServicesFactoryInstance.ScenariosService.updateScenario(this.scenario,
    			() => {
    				this.annuler();
    				NotificationServiceInstance.SendSuccess("Le scénario a été modifié avec succès.");
    				this.$emit("refresh");
    			});
    	} else {
    		ServicesFactoryInstance.ScenariosService.addScenario(this.scenario, () => {
    			this.annuler();
    			NotificationServiceInstance.SendSuccess("Le scénario a été créé avec succès.");
    			this.$emit("refresh");
    		});
    	}
	}
}




// WEBPACK FOOTER //
// ./src/components/scenarios/modalAjoutUpdateScenario/modalAjoutUpdateScenario.ts